export const VALENTINES_MODAL_KEY = "valentines_modal_seen";

export const VALENTINES_MODAL_LOGIN_SESSION_KEY =
  "valentines_modal_login_session";
